var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDivisor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 133,
    viewBox: "0 0 1440 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1459.75 13.9955L-8.74981 66.4955L-9.25 52.5044L1459.25 0.00439453L1459.75 13.9955ZM1461.2 30.4964L-7.3034 82.9964L-7.69641 72.0034L1460.8 19.5034L1461.2 30.4964ZM-6.85699 99.4974L1461.64 46.9974L1461.36 39.0025L-7.14282 91.5025L-6.85699 99.4974ZM1461.59 63.4983L-6.91058 115.998L-7.08922 111.002L1461.41 58.5015L1461.59 63.4983ZM-6.94631 132.999L1461.55 80.499L1461.45 77.5009L-7.0535 130.001L-6.94631 132.999Z",
    fill: "url(#paint0_diamond_1_703)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_diamond_1_703",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(754 133) rotate(176.812) scale(773.197 8551.4)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A285D0",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivisor);
export default __webpack_public_path__ + "static/media/divisor.60e88bb8cce32b6fa569fc4ccf56e5ae.svg";
export { ForwardRef as ReactComponent };